import { api } from './client'
import { responseStatus } from './upstreamStatus'

/**
 * AP Report — wraps cb-api's /reports/ap/* endpoints which proxy CB's
 * APReportController. Summary returns vendor-level aging; detail returns
 * per-transaction lines grouped by aging bucket.
 */

const apReportService = {
  async getSummary(filter) {
    const data = await api.post('/reports/ap/summary', filter)
    return data?.data || null
  },

  async getDetail(filter) {
    const data = await api.post('/reports/ap/detail', filter)
    return data?.data || null
  },

  /**
   * Spec 202 — detail's file: `POST /reports/ap/detail/export.{format}` with the run's own
   * filter as the body, which cb-api normalises exactly as it does the run's. (The old GET
   * route forwarded the filter raw, so the file could be asked something the run was not.)
   */
  exportRequest(filter, format) {
    return {
      url: `/api/v1/reports/ap/detail/export.${format}`,
      init: { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(filter) },
    }
  },

  async download(filter, format, getToken, fallbackName = `ap-report.${format}`) {
    const { url, init } = apReportService.exportRequest(filter, format)
    const token = await getToken()
    const resp = await fetch(url, { ...init, headers: { ...init.headers, Authorization: `Bearer ${token}` } })
    if (!resp.ok) throw new Error(`Export failed: ${responseStatus(resp)}`)
    const blob = await resp.blob()
    const dispo = resp.headers.get('content-disposition') || ''
    const m = /filename="?([^"]+)"?/.exec(dispo)
    const filename = m?.[1] || fallbackName
    const objUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = objUrl
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(objUrl)
  },
}

export default apReportService
